"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InfiniteIterator {
    constructor(initial, func) {
        this.initial = initial;
        this.func = func;
        this.current = null;
        this.nextElement = initial;
    }
    static of(initial, func) {
        return new InfiniteIterator(initial, func);
    }
    [Symbol.iterator]() {
        return this;
    }
    reset() {
        this.current = null;
        this.nextElement = this.initial;
    }
    hasNext() {
        try {
            if (this.nextElement == null) {
                this.nextElement = this.func(this.current);
            }
            return this.nextElement != null;
        }
        catch (e) {
            return false;
        }
    }
    next() {
        if (this.nextElement == null) {
            throw new Error("No more elements");
        }
        this.current = this.nextElement;
        this.nextElement = null;
        return { value: this.current, done: this.hasNext() };
    }
}
exports.default = InfiniteIterator;
